export async function googleSignIn(credential: string) {
  const res = await fetch("/api/auth/google", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ credential }),
  });
  return res.json();
}

export async function googleLogout() {
  const res = await fetch("/api/auth/logout", {
    method: "POST",
    credentials: "include",
  });
  return res.json();
}

export async function readNotification(notificationIds: number[]) {
  if (notificationIds.length === 0) return;
  await fetch("/api/ReadNotification", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ newReadIds: notificationIds }),
  });
}

export function trackDailyUsage(gameMode: string, gameType: string) {
  fetch("/api/TrackDailyUsage", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ type: gameMode, listType: gameType }),
  }).catch(() => {});
}

export async function saveBracket(data: {
  gameMode: string;
  gameType: string;
  bracketSize: number;
  artistSelected?: string;
  winnerSongName: string;
  winnerArtist: string;
  bracketData: unknown;
  isPublic?: boolean;
}) {
  const res = await fetch("/api/saveBracket", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(data),
  });
  return res.json();
}

export async function likeBracket(bracketId: number) {
  const res = await fetch("/api/likeBracket", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ bracketId }),
  });
  return res.json();
}

export async function unlikeBracket(bracketId: number) {
  const res = await fetch("/api/unlikeBracket", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ bracketId }),
  });
  return res.json();
}
